import AppointmentTypesEnum from './modules/AppointmentTypesEnum';

export default {
  AppointmentTypesEnum,
};
